import DownloadReportModal from './DownloadReportModal.component';

export default DownloadReportModal;